<template>
  <details class="assessment-details">
    <summary>{{ $t('levelTest.expandAssessment') }}</summary>
    <div class="assessment-body"><slot /></div>
  </details>
</template>

<script>
export default { name: 'AssessmentDetails' }
</script>

<style scoped>
.assessment-details { margin-top: var(--space-6); text-align: left; }
summary {
  padding: var(--space-3) 0;
  min-height: 44px;
  box-sizing: border-box;
  border-top: 1px solid var(--border-subtle);
  color: var(--ink-primary);
  font-size: var(--font-size-sm);
  font-weight: 600;
  cursor: pointer;
}
summary:focus-visible { outline: 2px solid var(--signal-active-strong); outline-offset: 2px; }
.assessment-body { padding-top: var(--space-3); overflow-wrap: anywhere; }
</style>
